export default "__VITE_ASSET__Ctmt5Gjy__"